import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("导出excel")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tips = _resolveComponent("Tips")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_MainLayout = _resolveComponent("MainLayout")!

  return (_openBlock(), _createBlock(_component_MainLayout, null, {
    default: _withCtx(() => [
      _createVNode(_component_Tips, { msg: "您可以选择查看指定渠道，指定业务，指定时间段的安装情况。" }),
      _createVNode(_component_el_form, {
        ref: "settlementFormRef",
        inline: true,
        model: _ctx.settlementForm,
        class: "demo-form-inline",
        rules: _ctx.settlementFormRules
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "业务名称:",
            prop: "soft_type"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.settlementForm.soft_type,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.settlementForm.soft_type) = $event)),
                placeholder: "请选择"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.channelSoftInfos, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.softid,
                      label: item.softname,
                      value: item.softid
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "日期:",
            required: "",
            prop: "yearMonth"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.settlementForm.yearMonth,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.settlementForm.yearMonth) = $event)),
                type: "month",
                placeholder: "请选择月份",
                style: {"width":"100%"},
                "value-format": "YYYY-MM"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _ctx.onSubmit
              }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(_component_el_button, {
                type: "primary",
                onClick: _ctx.upExcel
              }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }, 8, ["onClick"]), [
                [_vShow, _ctx.showUpExcel]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"]),
      _createVNode(_component_el_table, {
        data: _ctx.settlementTableData,
        "summary-method": _ctx.getSummaries,
        "show-summary": "",
        style: {"width":"100%"},
        stripe: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "remain",
            label: "月均周留存",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "settle_daily",
            label: "月均日结算量",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "settle",
            label: "月总结算量",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "price",
            label: "单价",
            sortable: "",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "cash",
            label: "结算金额",
            sortable: "",
            align: "center"
          })
        ]),
        _: 1
      }, 8, ["data", "summary-method"])
    ]),
    _: 1
  }))
}